import { queryOptions, useQuery } from '@tanstack/react-query'

import type { TFullCommunityApi } from '@/src/features/community/api/communityApi.types'
import { withFraternity } from '@/src/features/fraternity/utils/withFraternity'

import { fraternityApi } from '../api/fraternityApi'

type TUseFraternityOnboardingQueryOptions = {
  community?: Pick<TFullCommunityApi, 'tags'>
  enabled?: boolean
}

export const fraternityOnboardingQueryOptions = (options?: TUseFraternityOnboardingQueryOptions) =>
  queryOptions({
    queryKey: ['fraternity_onboarding'],
    queryFn: ({ signal }) => fraternityApi.getFraternityOnboarding({ signal }),
    enabled: options?.enabled ?? withFraternity(options?.community),
  })

export const useFraternityOnboardingQuery = (options?: TUseFraternityOnboardingQueryOptions) =>
  useQuery(fraternityOnboardingQueryOptions(options))
